






























helpers = require '../../helpers.coffee'

view_model = {
  components:
    createTemplateModal: require '../templates/create_modal'
    templateAutocomplete: require('../shared/autocomplete/templates')

  props: ['reference', 'action', 'flow', 'templates', 'validate', 'options', 'template_kind']

  data: ->
    selected_template_id: @action.template_id || ''
    action_template_id: @action.template_id
    show_select: !@action.template_id
    current_user: Session.current_user
    created_template: null
    pristine: true
    default_options:
      allow_create: false
      allow_blank: false
      preload: null

  computed:
    show_cancel_editing: ->
      @action_template_id && @show_select

    show_edit_button: ->
      @selected_template_id == -1 && @created_template

    template_modal_options: ->
      delete_button: @created_template != null

    select_validation: ->
      'required' if @validate && !@flow.semi_automatic

    create_modal_element_id: ->
      'create-template-modal-' + @action.step

    input_group_class: ->
      {
        'group-without-buttons': !@show_cancel_editing && !@show_edit_button
        'group-with-edit-and-cancel-button': @show_cancel_editing && @show_edit_button,
        'group-with-cancel-button': @show_cancel_editing && !@show_edit_button
        'group-with-edit-button': !@show_cancel_editing && @show_edit_button
      }

  methods:
    templateSelected: (template) ->
      @selected_template_id = template.id

    validateAll: ->
      @setDirty()
      @$validator.validateAll({@selected_template_id})
      EventsBus.$emit 'templates-picker-errors', { @errors, @reference }

    revalidate: ->
      EventsBus.$emit 'validate-all' unless @pristine

    cancelEditing: ->
      @selected_template_id = @action_template_id
      @show_select = false
      @$emit 'cancel-editing', { @action_template_id, @reference }

    editTemplate: ->
      @show_select = true
      @selected_template_id = ''

    createTemplate: (data) ->
      data.attr.template.id = @selected_template_id
      @created_template = data.attr.template
      @$emit 'change', { template: @created_template, @reference }
      Loader.off()

    cancelTemplateChange: ->
      @selected_template_id = '' unless @created_template

    openCreateTemplateModal: (templateAttrs)->
      templateAttrs.id = @create_modal_element_id
      EventsBus.$emit 'confirm-modal-show', templateAttrs

    destroyCreatedTemplate: ->
      @created_template = null
      @selected_template_id = ''

  watch:
    selected_template_id: (template_id) ->
      if template_id == 'create'
        @selected_template_id = -1
      else
        if template_id == -1
          template = @created_template
        else
          template = new Template({ id: template_id })

        @$emit 'change', { template, @reference }

    template_kind: (kind) ->
      @selected_template_id = -1
      @show_select = true

  mounted: ->
    Tooltip.initialize()

  created: ->
    @errors.clear()
    EventsBus.$on 'validate-all', @validateAll

  beforeDestroy: ->
    EventsBus.$off 'validate-all', @validateAll
}

exports.default = helpers.vue_include(view_model, helpers.form)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/picker.vue